import { type ThemeOptionVariant } from '@dhl-ui/components'

// MT 123 40
// D  110 36
// MD 147 48
// LG 172 56
// XL 196 64

// TODO: spec  for all themes and our logo...
export const dimensions: Record<ThemeOptionVariant, { width: number; height: number }> = {
  mobile: {
    width: 123,
    height: 40,
  },
  tablet: {
    width: 123,
    height: 40,
  },
  desktop: {
    width: 110,
    height: 36,
  },
  md: {
    width: 147,
    height: 48,
  },
  lg: {
    width: 172,
    height: 56,
  },
  xl: {
    width: 306,
    height: 100,
  },
}
